import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "confirm-modal" }
const _hoisted_2 = { class: "modal-inner" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "body-container" }
const _hoisted_6 = { class: "content-text" }
const _hoisted_7 = { class: "btn-group" }

import { reactive, toRefs, onMounted, onBeforeMount, watch } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    isShow: { // 是否显示弹窗
        type: Boolean,
        default: false,
    },
    title: { // 弹窗标题
        type: String,
        default: '',
    },
    content: { // 弹窗内容
        type: String,
        default: '',
    },
    closeText: { // 关闭按钮文本
        type: String,
        default: '取消',
    },
    confirmText: { // 确定按钮文本
        type: String,
        default: '确定',
    },
},
  emits: ["onClose", "onCancle", "onConfirm"],
  setup(__props, { emit: __emit }) {

/**
 * 二次确认弹窗
 * @author Mr.Nuerdong
*/
const props = __props
const emit = __emit

function handleCancle() {
    emit('onClose')
    emit('onCancle')
}

function handleConfirm() {
    emit('onConfirm')
}



return (_ctx: any,_cache: any) => {
  const _component_vkn_button = _resolveComponent("vkn-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("i", {
          class: "iconfont-line vk_gb_line1",
          onClick: handleCancle
        }),
        _createElementVNode("p", _hoisted_4, _toDisplayString(props.title), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(props.content), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_vkn_button, {
            label: props.closeText,
            type: "info",
            size: "small",
            onClick: handleCancle
          }, null, 8, ["label"]),
          _createVNode(_component_vkn_button, {
            label: props.confirmText,
            type: "primary",
            size: "small",
            onClick: handleConfirm
          }, null, 8, ["label"])
        ])
      ])
    ])
  ]))
}
}

})